import React from "react"
import { Alert, Button, ButtonGroup, Input } from "reactstrap"
import { Container } from "./styles"

const Alerts = (props) => {

    function setTerm() {
        localStorage.setItem('termgeo', true);
        window.location.reload()
    }
    function setTermClose() {
        localStorage.setItem('termgeo', false);
        window.open("about:blank", "_self");
        window.close()
    }

    return (
        <>
            <div>
                <Alert color={props.color}>
                    <h4 className="alert-heading">

                        {props.title || 'Alert'}
                    </h4>
                    <p>
                        <Input
                            addon
                            aria-label="Checkbox for following text input"
                            type="checkbox"
                            checked
                        />
                        {' '}
                        {props.textBody}
                    </p>
                    <hr />
                    <Container>


                        <ButtonGroup>
                            <Button className='btn btn-success'
                                onClick={() => { props.function || setTerm() }}
                            >
                                {props.textButton || 'Aceitar'}
                            </Button>

                        </ButtonGroup>
                        {'  '}
                        <ButtonGroup>

                            <Button className='btn btn-warning'
                                onClick={() => { props.function || setTermClose() }}
                            >
                                {props.textButton || 'Não Aceitar'}
                            </Button>
                        </ButtonGroup>


                    </Container>


                </Alert>
            </div>
        </>


    )
}

export default Alerts